import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Container da tela de detalhe do pedido.
 *
 * O `max-width` centraliza o conteúdo em monitores largos sem esticar as linhas de texto, e o
 * padding é enxuto porque a tela também é usada dentro de um drawer, que já tem recuo próprio.
 * A largura real é medida por `useLarguraElemento` para decidir entre uma e duas colunas —
 * media query não serviria, já que ela mede a janela e não o espaço recebido pelo componente.
 */
export const Container = styled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: 1280,
    margin: "0 auto",
    padding: theme.spacing(2, 1.5, 4),
    display: "flex",
    flexDirection: "column",
}));
